import React from 'react'
import { SplitButtonDropdown, ActionItem } from 'view/components/menus'
import { Translation, Locale } from 'locale'
import { clientActionUpdateIssuerOrganisation, EntityTypeEnum, IssuerOrganisationDetail, Permission, WorkflowActions } from 'api'
import { ModalConsumerProps, NotificationType, withModal } from 'view/shared/modal'
import { useDispatch } from 'react-redux'
import { ActionsButtonProps } from 'view/components/datagrid'
import { useSelector } from 'react-redux'
import { createUserHasPermissionSelector } from 'selectors/userSelectors'
import { IssuerOrganisationDialog } from '../IssuerOrganisationDialog'
import { NotificationActions } from 'store/notification'

interface IssuerOrganisationsActionsButtonComponentProps extends ModalConsumerProps, ActionsButtonProps<IssuerOrganisationDetail> {}

const canEditSelector = createUserHasPermissionSelector(Permission.ISSUER_ORGANISATION_MANAGE)

const IssuerOrganisationsActionsButtonComponent: React.FC<IssuerOrganisationsActionsButtonComponentProps> = ({ showModal, items }) => {
  const dispatch = useDispatch()
  const canEdit = useSelector(canEditSelector)

  const handleEditIssuerOrganisation = (issuerOrganisations: IssuerOrganisationDetail[]) => {
    const correlatedResponseCallback = (workflowId: string) => {
      showModal(
        <IssuerOrganisationDialog workflowId={workflowId} issuerOrganisationEntityId={issuerOrganisations[0].issuerOrganisation.id} />
      )
    }
    dispatch(
      WorkflowActions.createEditWorkflow(
        EntityTypeEnum.ISSUER_ORGANISATION,
        issuerOrganisations[0].issuerOrganisation.id,
        correlatedResponseCallback
      )
    )
  }

  const handleDeleteIssuerOrganisation = (issuerOrganisations: IssuerOrganisationDetail[]) => {
    dispatch(
      WorkflowActions.createEditWorkflow(
        EntityTypeEnum.ISSUER_ORGANISATION,
        issuerOrganisations[0].issuerOrganisation.id,
        (workflowId: string) => {
          dispatch(
            WorkflowActions.createEntityDeleteReferenceData(
              [{ entityId: issuerOrganisations[0].issuerOrganisation.id, entityType: EntityTypeEnum.ISSUER_ORGANISATION }],
              workflowId
            )
          )
          dispatch(WorkflowActions.createSubmitWorkflow(workflowId))
        }
      )
    )
  }

  const handleUpdateItemFromRefinitiv = async (issuerOrganisationId: string) => {
    const titleText = Locale.translate(Translation.TC_PROMPT_TITLE_UPDATE_FROM_REFINITIV)
    const messageText = Locale.translate(Translation.SC_PROMPT_MSG_UPDATE_FROM_REFINITIV)
    const updateIssuerOrganisation = clientActionUpdateIssuerOrganisation({
      issuerOrganisationId: issuerOrganisationId
    })

    dispatch(
      NotificationActions.showDialog({
        type: NotificationType.Confirm,
        titleText: titleText,
        messageText: messageText,
        buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
        defaultButton: Translation.TC_BUTTON_YES,
        cancelButton: Translation.TC_BUTTON_NO,
        responseMap: {
          [Translation.TC_BUTTON_YES]: [updateIssuerOrganisation]
        }
      })
    )
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: () => handleEditIssuerOrganisation(items),
      enabled: canEdit
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE),
      onClick: () => handleDeleteIssuerOrganisation(items),
      enabled: canEdit
    },
    {
      label: Locale.translate(Translation.TC_ACTION_UPDATE_FROM_RIFINITIV),
      onClick: () => handleUpdateItemFromRefinitiv(items[0].issuerOrganisation.id),
      enabled: canEdit
    }
  ]
  return <SplitButtonDropdown actions={actions} maxButtons={1} autoHideEllipsis={true} />
}

export const IssuerOrganisationsActionsButton = withModal(IssuerOrganisationsActionsButtonComponent)
